<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="container-fluid">
    <div class="user-profile social-app-profile">
        <div class="row">
            <div class="col-sm-12 social-app-tab">
                <div class="card hovercard mb-0">
                    <div class="cardheader socialheader" [ngStyle]="{'background-image': 'url('+userData.coverPhoto+')'}"></div>
                    <div class="user-image">
                        <div class="avatar" style=" text-align: left !important; margin-left: 20px;"><img alt="" [src]="userData.contactLogo"></div>
                    </div>
                    <div class="info market-tabs p-0">
                        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                            <li [ngbNavItem]="1" disabled="true">
                                <a ngbNavLink style="text-align: left !important; margin-left: 20px; height: auto;">
                                    <div class="title"><a target="_blank" href="">{{userData.firstName}} {{userData.lastName}}</a></div>
                                    <div class="desc mt-2">
                                        {{userData.title}}
                                        <div class="feed-time-date" style="">
                                            {{userData.portalAccount.name}}
                                        </div>
                                        <div *ngIf="userData.allowEmailAddress" class="feed-time-date" style="">
                                            {{userData.eMail}}
                                        </div>
                                        <div *ngIf="userData.allowMobileNumber" class="feed-time-date" style="">
                                            {{userData.mobilePhone}}
                                        </div>

                                        <div style="padding-top: 20px; padding-bottom: 20px; text-transform: initial;" [innerHTML]="userData.summary"></div>
                                    </div>
                                </a>
                                <div style="padding-left: 30px; padding-right: 30px; position: relative; text-align: left; padding-top: 20px;">
                                    <button (click)="sendConnectionRequestInvitation()" style="margin-bottom:16px" *ngIf="connectionStatus == 'not_friend'" class="btn mygistec-main-btn">Add connection</button>
                                    <button (click)="removeConnectionFromMyList(userData.id)" style="margin-bottom:16px" *ngIf="connectionStatus == 'friend'" class="btn mygistec-main-btn">Remove connection</button>
                                    <button (click)="ignoreUserConnection(myId, userData.id)" style="margin-bottom:16px" *ngIf="connectionStatus == 'sent_conn'" class="btn mygistec-main-btn">Cancel request</button>
                                    <button (click)="acceptUserConnection(myId, userData.id)" style="margin-bottom:16px" *ngIf="connectionStatus == 'conn_req'" class="btn mygistec-main-btn">Accept request</button>
                                    <button (click)="ignoreUserConnection(userData.id, myId)" style="margin-left: 20px;margin-bottom:16px" *ngIf="connectionStatus == 'conn_req'" class="btn mygistec-main-btn">Ignore request</button>
                                </div>
                            </li>
                            
                        </ul>
                        <div [ngbNavOutlet]="nav" class="mt-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends-->